import ListMap from '../core/ListMap';
import MetaPage from './MetaPage';

class MetaPageList extends ListMap {
  constructor(args = {}) {
    const { data = {} } = args;

    const pageList = Object.entries(data).map(v => new MetaPage({
      ...args,
      data: {
        name: v[0],
        value: v[1],
      },
    }));

    super({
      ...args,
      data: pageList,
    });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  constructItem(key) {
    return new MetaPage({ data: { name: key } });
  }

  export() {
    const page = {};
    this.itemList.forEach((v) => {
      page[v.attr('name')] = v.attr('value');
    });

    return page;
  }
}

export default MetaPageList;
